import {
  Swiper,
  Pagination,
  Navigation,
  EffectFade,
  Autoplay,
  Keyboard,
} from 'swiper/dist/js/swiper.esm.js';

export default class Logo {
  constructor(elem, paramters) {
    this.swipers = [];
    this.addSwiper(elem, paramters);
  }

  addSwiper(elem, parameters) {
    const defaultParameters = {
      slidesPerView: 1,
      speed: 800,
      centeredSlides: true,
      loop: true,

      autoplay: {
        delay: 4000,
      },

      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },

      keyboard: {
        enabled: true,
      },

      pagination: {
        el: elem + ' .o-slider__pagination',
        clickable: true,
        hideOnClick: false,
        // Classes
        bulletClass: 'o-slider__bullet',
        bulletActiveClass: 'o-slider__bullet--active',
        modifierClass: 'o-slider__bullet--',
        currentClass: 'o-slider__bullet--current',
        totalClass: 'o-slider__bullet--total',
        hiddenClass: 'o-slider__bullet--hidden',
      },

      // Classes
      containerModifierClass: 'o-slider--',
      slideClass: 'o-slider__slide',
      slideActiveClass: 'o-slider__slide--active',
      slideDuplicateActiveClass: 'o-slider__slide--duplicate-active',
      slideVisibleClass: 'o-slider__slide--visible',
      slideDuplicateClass: 'o-slider__slide--duplicate',
      slideNextClass: 'o-slider__slide--next',
      slideDuplicateNextClass: 'o-slider__slide--duplicate-next',
      slidePrevClass: 'o-slider__slide--prev',
      slideDuplicatePrevClass: 'o-slider__slide--duplicate-prev',
      wrapperClass: 'o-slider__wrapper',
    };

    Swiper.use([Navigation, Pagination, EffectFade, Autoplay, Keyboard]);

    let swiper = new Swiper(elem, Object.assign({
      ...defaultParameters,
      ...parameters,
    }));

    this.swipers = this.swipers.concat(swiper);

    this.swipers.forEach(function (swiper) {
      if (swiper.slides && swiper.slides.length - 2 == 1) {
        swiper.autoplay.stop();

        const pagination = document.querySelector(elem + ' .o-slider__pagination');

        if(pagination) {
          pagination.style.display = 'none';
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/slider.js